module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-17.aea77b3b.jpg";